import { apiClient } from '../../axios';
import {
  GetFillHistoriesParams,
  GetFillHistoriesResponse,
  GetOrderHistoriesParams,
  GetOrderHistoriesResponse,
  GetPositionHistoryListParams,
  HighestPnlPosition,
  PositionHistoryList,
} from './types';

export const getHighestPnlPositionApi = (params: { isAirdrop?: boolean }) =>
  apiClient.get<HighestPnlPosition>('/v2/positions/best', { params });

export const getPositionHistoryListApi = (params: GetPositionHistoryListParams) =>
  apiClient.get<PositionHistoryList>('/v2/positions/history', { params });

export const getFillHistoriesApi = (params: GetFillHistoriesParams) =>
  apiClient.get<GetFillHistoriesResponse>('/v2/execution/history', { params });

export const getOrderHistoriesApi = (params: GetOrderHistoriesParams) =>
  apiClient.get<GetOrderHistoriesResponse>('/v2/order/history', { params });
